var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAnimated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eG7BebRLwhs1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 369",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs2",
    transform: "matrix(1 0 0 1 0.419208 0)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs3",
    transform: "matrix(0.037307 0.999304 0.999304 -0.037307 764.9 107.381)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs4",
    d: "M-6.331,-74.803L75.1,-74.803L48.489,-5.484L20.343,-5.635L-6.331,-74.803Z",
    clipRule: "evenodd",
    fill: "rgb(247,224,125)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs5",
    transform: "matrix(-0.945406 -0.325895 -0.325895 0.945406 762.498 141.887)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs6",
    d: "M-23.193,-12.4L6.888,-12.4L-3.412,13.794L-25.538,-6.336C-27.895,-8.48,-26.379,-12.401,-23.193,-12.4",
    clipRule: "evenodd",
    fill: "rgb(104,93,74)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs7",
    transform: "matrix(1 0 0 1 702.099 149.503)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs8",
    d: "M0,21.721C-0.26,14.703,-6.374,9.198,-9.894,8.486C-6.514,7.499,-0.749,1.561,-1.009,-5.442C-1.255,-12.08,-6.77,-17.421,-10.344,-18.581C-6.924,-20.024,-1.762,-25.742,-2.008,-32.359C-2.274,-39.535,-8.66,-45.13,-12.133,-45.632L-623.753,-14.078L-620.659,67.353L-9.113,35.705C-5.775,34.935,0.266,28.886,0,21.721",
    clipRule: "evenodd",
    fill: "rgb(251,199,38)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs9",
    transform: "matrix(1 0 0 1 63.2819 217.847)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eG7BebRLwhs10",
    width: 0.001,
    height: 0.001,
    rx: 0,
    ry: 0,
    clipRule: "evenodd",
    fill: "rgb(171,165,171)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs11",
    transform: "matrix(-0.998672 0.051515 0.051515 0.998672 65.4232 218.229)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eG7BebRLwhs12",
    width: 21.161,
    height: 81.717,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 1 -19.042 -82.208)",
    clipRule: "evenodd",
    fill: "rgb(171,165,171)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs13",
    transform: "matrix(1 0 0 1 59.0741 219.993)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs14",
    d: "M0,-83.754L-30.051,-82.205C-41.587,-81.61,-50.457,-71.776,-49.862,-60.24L-47.808,-20.406C-47.213,-8.87,-37.38,0,-25.843,-0.595L4.208,-2.145L0,-83.754Z",
    clipRule: "evenodd",
    fill: "rgb(227,130,181)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs15",
    transform: "matrix(1 0 0 1 619.205 354.333)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs16",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs17",
    d: "M0,-339.665L-464.893,-339.665C-494.239,-339.665,-516.938,-313.936,-513.28,-284.819L-482.862,-42.688C-479.798,-18.297,-459.058,0,-434.475,0L-30.418,0C-5.835,0,14.904,-18.297,17.969,-42.688L48.387,-284.819C52.045,-313.936,29.346,-339.665,0,-339.665",
    clipRule: "evenodd",
    fill: "rgb(137,184,93)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs18",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs19",
    transform: "matrix(1 0 0 1 348.271 143.177)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs20",
    d: "M0,12.109L-21.294,10.118L-20.324,-1.285C-20.161,-3.2,-21.579,-4.882,-23.495,-5.045C-25.425,-5.195,-27.096,-3.786,-27.255,-1.873L-28.22,9.471L-50.47,7.39L-50.73,-7.464C-50.764,-9.386,-52.331,-10.992,-54.272,-10.881C-56.191,-10.849,-57.72,-9.265,-57.689,-7.343L-57.442,6.738L-74.96,5.101L-74.046,-3.813C-73.852,-5.724,-75.242,-7.433,-77.151,-7.629C-79.088,-7.824,-80.769,-6.434,-80.97,-4.523L-81.891,4.453L-98.127,2.935L-95.469,-9.251C-95.061,-11.129,-96.251,-12.983,-98.129,-13.391C-99.986,-13.806,-101.858,-12.611,-102.269,-10.734L-105.109,2.282L-123.511,0.561L-121.953,-12.158C-121.718,-14.065,-123.074,-15.802,-124.983,-16.035C-126.858,-16.256,-128.625,-14.911,-128.857,-13.005L-130.439,-0.086L-151.652,-2.07L-149.16,-16.521C-148.831,-18.415,-150.104,-20.215,-151.996,-20.54C-153.888,-20.86,-155.69,-19.598,-156.015,-17.704L-158.6,-2.719L-176.536,-4.396C-178.463,-4.58,-180.144,-3.167,-180.323,-1.256C-180.503,0.657,-179.099,2.352,-177.186,2.532L-159.786,4.159L-162.49,19.836C-162.819,21.73,-161.546,23.53,-159.654,23.855C-159.453,23.89,-159.256,23.907,-159.059,23.907C-157.395,23.907,-155.925,22.712,-155.635,21.019L-152.838,4.808L-131.285,6.823L-132.741,18.708C-132.976,20.616,-131.62,22.352,-129.711,22.586C-129.569,22.603,-129.427,22.612,-129.286,22.612C-127.553,22.612,-126.052,21.318,-125.837,19.556L-124.357,7.471L-106.602,9.131L-110.034,24.863C-110.442,26.741,-109.252,28.595,-107.374,29.003C-107.125,29.059,-106.876,29.085,-106.631,29.085C-105.029,29.085,-103.59,27.974,-103.234,26.347L-99.621,9.784L-82.602,11.375L-83.561,20.72C-83.754,22.631,-82.364,24.339,-80.455,24.535C-80.334,24.547,-80.213,24.554,-80.095,24.554C-78.331,24.554,-76.823,23.22,-76.636,21.429L-75.671,12.023L-57.319,13.739L-57.042,29.55C-57.008,31.45,-55.458,32.969,-53.563,32.969C-53.542,32.969,-53.521,32.969,-53.5,32.967C-51.581,32.934,-50.052,31.35,-50.083,29.429L-50.347,14.39L-28.81,16.404L-29.842,28.547C-30.005,30.461,-28.587,32.144,-26.671,32.307C-26.57,32.315,-26.47,32.32,-26.373,32.32C-24.585,32.32,-23.063,30.949,-22.911,29.135L-21.884,17.052L-0.65,19.037C-0.54,19.047,-0.429,19.052,-0.322,19.052C1.453,19.052,2.971,17.7,3.137,15.896C3.317,13.984,1.913,12.289,0,12.109",
    clipRule: "evenodd",
    fill: "rgb(119,165,70)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs21",
    transform: "matrix(1 0 0 1 619.205 99.4463)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs22",
    d: "M0,-84.779L-464.893,-84.779C-494.239,-84.779,-516.938,-59.05,-513.281,-29.933L-509.532,-0.095C-465.2,-1.128,-464.345,-32.362,-418.528,-32.362C-371.957,-32.362,-371.957,0,-325.388,0C-278.805,0,-278.805,-32.362,-232.223,-32.362C-185.624,-32.362,-185.624,0,-139.026,0C-92.443,0,-92.443,-32.362,-45.859,-32.362C-0.211,-32.362,0.851,-1.41,44.642,-0.121L48.387,-29.933C52.045,-59.05,29.346,-84.779,0,-84.779",
    clipRule: "evenodd",
    fill: "rgb(104,93,74)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs23",
    mask: "url(#eG7BebRLwhs28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eG7BebRLwhs24",
    width: 457.221529,
    height: 189.660727,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 0.888448 161.615856 149.366754)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs25",
    transform: "matrix(1 0 0 1 0.000001 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "eG7BebRLwhs26",
    rx: 29.868007,
    ry: 29.868007,
    transform: "matrix(1 0 0 1 505.110534 194.92206)",
    fill: "rgb(104,93,74)",
    stroke: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eG7BebRLwhs27",
    rx: 29.868007,
    ry: 29.868007,
    transform: "matrix(1 0 0 1 268.08106 209.192533)",
    fill: "rgb(104,93,74)",
    stroke: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eG7BebRLwhs28",
    "mask-type": "luminance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs29",
    transform: "matrix(1 0 0 1 -0.000382 0)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs30",
    transform: "matrix(1 0 0 1 593.905 286.524)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs31",
    d: "M0,-96.027C2.566,-46.976,-35.117,-5.132,-84.168,-2.566C-133.219,0,-175.063,-37.684,-177.629,-86.734L0,-96.027Z",
    clipRule: "evenodd",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "eG7BebRLwhs32",
    transform: "matrix(1 0 0 1 357.118 298.912)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eG7BebRLwhs33",
    d: "M0,-96.027C2.566,-46.976,-35.117,-5.132,-84.168,-2.566C-133.219,0,-175.063,-37.684,-177.629,-86.734L0,-96.027Z",
    clipRule: "evenodd",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimated);
export default __webpack_public_path__ + "static/media/logo-animated.80623a02dc917c9e71bd89f298cee813.svg";
export { ForwardRef as ReactComponent };